import { render, staticRenderFns } from "./policyInfoBuLu.vue?vue&type=template&id=7d2f83ba&scoped=true&"
import script from "./policyInfoBuLu.vue?vue&type=script&lang=js&"
export * from "./policyInfoBuLu.vue?vue&type=script&lang=js&"
import style0 from "./policyInfoBuLu.vue?vue&type=style&index=0&id=7d2f83ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f83ba",
  null
  
)

export default component.exports